import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M22 9l-10 -4l-10 4l10 4l10 -4v6","key":"svg-0"}],["path",{"d":"M6 10.6v5.4a6 3 0 0 0 12 0v-5.4","key":"svg-1"}]]

const IconSchool = createReactComponent('outline', 'school', 'School', __iconNode);

export default IconSchool;